export enum EventFormat {
	ONLINE = "ONLINE",
	ONSITE = "ONSITE",
	HYBRID = "HYBRID",
}
